import {gql} from '@apollo/client'
import {Flow, FlowGenerator, UseFlowQuery} from 'features/procedures/Flow/Flow'
import {useQuery} from 'hooks/graphql'

const PARENTAL_LEAVE_FLOW_QUERY = gql`
  query ParentalLeaveFlowQuery($procedureStatusId: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        employee {
          id
          healthInsurance {
            id
            joined
          }
          welfarePensionInsurance {
            id
            joined
          }
          employmentInsurance {
            id
            joined
          }
          currentOffice {
            id
            healthInsuranceType
          }
        }
      }
    }
  }
`

interface FlowQueryData {
  client: {
    id: string
    procedureStatus: {
      id: string
      employee: {
        id: string
        healthInsurance?: {
          id: string
          joined: boolean
        }
        welfarePensionInsurance?: {
          id: string
          joined: boolean
        }
        employmentInsurance?: {
          id: string
          joined: boolean
        }
        currentOffice: {
          id: string
          healthInsuranceType: 'kyokai' | 'its' | 'other'
        }
      }
    }
  }
}

const useFlowQuery: UseFlowQuery<FlowQueryData> = ({procedureStatusId}) => {
  return useQuery<FlowQueryData>(PARENTAL_LEAVE_FLOW_QUERY, {
    variables: {procedureStatusId},
    fetchPolicy: 'network-only',
  })
}

const makeFlow: FlowGenerator<FlowQueryData> = function* (data) {
  const employee = data.client.procedureStatus.employee
  const healthInsuranceJoined = employee.healthInsurance?.joined
  const welfarePensionInsuranceJoined = employee.welfarePensionInsurance?.joined
  const employmentInsuranceJoined = employee.employmentInsurance?.joined
  const healthInsuranceType = employee.currentOffice.healthInsuranceType

  yield 'ChildcareInfo'

  if (healthInsuranceType === 'kyokai' || healthInsuranceType === 'other') {
    if (healthInsuranceJoined || welfarePensionInsuranceJoined) {
      yield 'R507'
    }
    if (employmentInsuranceJoined) {
      yield 'R512'
    }
  } else if (healthInsuranceType === 'its') {
    if (healthInsuranceJoined || welfarePensionInsuranceJoined) {
      yield 'R508'
    }
    if (employmentInsuranceJoined) {
      yield 'R512'
    }
  }

  yield 'Attachments'
}

export const ParentalLeaveFlow = () => <Flow procedureContext="admin" makeFlow={makeFlow} useFlowQuery={useFlowQuery} />
